




















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Package } from "../models/package";
import { PackageGroup } from "../models/packagegroup";

@Component
export default class Flag extends Vue {
  @Prop() public title?: string;
  @Prop({ default: 50 }) public Size?: number;

  get iconName() {
    const title = (this.title || "").toLowerCase();
    if (!title) {
      return "";
    }
    if (title.search(/za/i) > -1) {
      return "za";
    }
    return "other";
  }

  get x() {
    return (this.Size || 50) * 1.3;
  }
  get y() {
    return this.Size || 50;
  }

  get stl() {
    return { width: `${this.x}px`, height: `${this.y}px` };
  }

  get stlSvg() {
    return {
      width: `${(this.x / 100) * 90}px`,
      height: `${(this.y / 100) * 90}px`,
      paddingLeft: `${(this.x / 100) * 10}px`,
      paddingTop: `${(this.y / 100) * 8}px`,
      paddingBottom: `${(this.y / 100) * 10}px`,
    };
  }
}
